import { apiClient } from './client'
import type { DashboardUserRole } from './auth'
import type { MeasurementUnit } from '../measurements'

export type DashboardUser = {
  id: string
  email: string
  displayName?: string | null
  role: DashboardUserRole
  createdAt: string
  updatedAt: string
  lastLoginAt?: string | null
  operatorId?: string | null
  isDisabled: boolean
  measurementUnit: MeasurementUnit
}

export async function getDashboardUsers() {
  const { data } = await apiClient.get<DashboardUser[]>('/api/admin/users')
  return data
}

export type CreateDashboardUserRequest = {
  email: string
  password: string
  displayName?: string
  role: Exclude<DashboardUserRole, 'Guest'>
  operatorId?: string | null
}

export async function createDashboardUser(payload: CreateDashboardUserRequest) {
  const { data } = await apiClient.post<DashboardUser>('/api/admin/users', payload)
  return data
}

export async function getCurrentAdminUser() {
  const { data } = await apiClient.get<DashboardUser>('/api/admin/users/me')
  return data
}

export async function updateCurrentAdminUserPreferences(payload: { measurementUnit: MeasurementUnit }) {
  const { data } = await apiClient.put<DashboardUser>('/api/admin/users/me/preferences', payload)
  return data
}

export async function updateDashboardUserPreferences(userId: string, payload: { measurementUnit: MeasurementUnit }) {
  const { data } = await apiClient.put<DashboardUser>(`/api/admin/users/${userId}/preferences`, payload)
  return data
}

export async function setUserDisabledStatus(userId: string, isDisabled: boolean) {
  const { data } = await apiClient.put<DashboardUser>(`/api/admin/users/${userId}/disabled`, { isDisabled })
  return data
}

export type UpdateUserRoleRequest = {
  role: DashboardUserRole
  operatorId?: string | null
}

export async function updateUserRole(userId: string, payload: UpdateUserRoleRequest) {
  const { data } = await apiClient.put<DashboardUser>(`/api/admin/users/${userId}/role`, payload)
  return data
}

export async function deleteDashboardUser(userId: string) {
  await apiClient.delete(`/api/admin/users/${userId}`)
}

export async function sendDashboardUserPasswordReset(userId: string) {
  await apiClient.post(`/api/admin/users/${userId}/password-reset`)
}
